import { AfterViewInit, Component, ElementRef, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonButtonRowWidget, CommonSelectFieldWidget, CommonTextFieldWidget } from "@eforall/common";
import { EditStatusLogFormService } from "./edit-status-log-form.service";
import { FormsModule } from "@angular/forms";
import { DashboardDescriptiveSelectFieldWidget } from "@eforall/dashboard";

@Component({
	selector: 'acc-application-edit-status-log-part',
	standalone: true,
	imports: [
		CommonSelectFieldWidget,
		CommonTextFieldWidget,
		CommonButtonRowWidget,
		DashboardDescriptiveSelectFieldWidget,
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './edit-status-log.part.html'
})
export class EditStatusLogPart implements AfterViewInit {
	public readonly form = new EditStatusLogFormService();
	public saveButton = viewChild.required<ElementRef<HTMLButtonElement>>('statusSaveBtn');

	ngAfterViewInit() {
		this.form.form.setSubmitButton(
			this.saveButton(),
			async (values, changed: string[]) => {
				const toAccApplicationStatusId = values.statusId;
				const accApplicationId = this.form.accAppDialogDataService.dialogData()?.details.accApplicationId;
				if (accApplicationId && !this.form.disableSaveBtn()) {
					await this.form.accAppDialogDataService.changeAccApplicationStatusAndLog(
						accApplicationId,
						toAccApplicationStatusId,
						values.note,
						this.form.deferApplication()
					);

					this.form.resetValues();
				}
			}
		)
	}

}